export const isLoading = 'isLoading'
export const isDisabled = 'isDisabled'
export const excelJson = 'excelJson'
